import { Dimensions, Platform } from 'react-native';
const SCREEN_WIDTH = Math.min(Dimensions.get('screen').width, Dimensions.get('screen').height);
const FACTOR = 414;
export const _rem = (num) => {
    return Number(((SCREEN_WIDTH / FACTOR) * num).toFixed(1));
};
export const _remWith = (baseWidth, num) => {
    return Number(((baseWidth / FACTOR) * num).toFixed(1));
};
/**
 *
 * @param num 414设计稿下的尺寸
 * @returns
 */
export const rem = (num, baseWidth) => {
    if (Platform.OS === 'web') {
        return num;
    }
    if (baseWidth) {
        return _remWith(baseWidth, num);
    }
    return _rem(num);
};
